import useFetch from '../../../hooks/useFetch';
import { useState } from 'react';
import { ServiceEvents } from '../shared/interfaces';
import { buildEndpoint } from '../EndPoints';

const useOfficialPublicationService = () => {
    const { doGet, doPost } = useFetch();
    
    const [fetchingGetFormalExaminationId, setFetchingGetFormalExaminationId] = useState(false);
    const [fetchingGetOfficialPublication, setFetchingGetOfficialPublication] = useState(false);
    const [fetchingCreateOfficialPublication, setFetchingCreateOfficialPublication] = useState(false);
    const [fetchingUpdateOfficialPublication, setFetchingUpdateOfficialPublication] = useState(false);
    const [fetchingSendPaymentEmail, setFetchingSendPaymentEmail] = useState(false);
    const [fetchingCreateFlowPayment, setFetchingCreateFlowPayment] = useState(false);
    const [fetchingInapiAutofill, setFetchingInapiAutofill] = useState(false);
    
    const BASE_PATH = 'brand-registrations/official-publication';
    
    /**
     * Obtener formal_examination_id a partir del brand_registration_id
     */
    const getFormalExaminationId = (brandRegistrationId: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: buildEndpoint(`brand-registrations/brand-registrations/${brandRegistrationId}/formal-examination-id`),
            setFetching: setFetchingGetFormalExaminationId
        });
    };
    
    /**
     * Obtener estado del pago de publicación (para página de éxito/error)
     */
    const getPublicationPaymentStatus = (publicationId: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/${publicationId}/payment-status`),
            setFetching: setFetchingGetOfficialPublication
        });
    };
    
    /**
     * Obtener publicación oficial por ID de examen de forma
     */
    const getOfficialPublication = (formalExaminationId: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/${formalExaminationId}/show`),
            setFetching: setFetchingGetOfficialPublication
        });
    };
    
    /**
     * Crear o actualizar publicación oficial
     */
    const createOfficialPublication = (data: any, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/create`),
            body: data,
            setFetching: setFetchingCreateOfficialPublication
        });
    };
    
    /**
     * Actualizar publicación oficial (después del pago)
     */
    const updateOfficialPublication = (publicationId: number, data: any, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/${publicationId}/update`),
            body: data,
            setFetching: setFetchingUpdateOfficialPublication
        });
    };
    
    /**
     * Enviar email de solicitud de pago al cliente
     */
    const sendPaymentEmail = (publicationId: number, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/send-payment-email`),
            body: { publication_id: publicationId },
            setFetching: setFetchingSendPaymentEmail
        });
    };
    
    /**
     * Crear orden de pago en Flow para la publicación
     */
    const createFlowPayment = (publicationId: number, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint('brand-registrations/payment/publication-flow/create'),
            body: { publication_id: publicationId },
            setFetching: setFetchingCreateFlowPayment
        });
    };
    
    /**
     * Obtener datos de INAPI para autocompletar la publicación
     */
    const getInapiDataForAutofill = (publicationId: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/${publicationId}/inapi-autofill`),
            setFetching: setFetchingInapiAutofill
        });
    };
    
    return {
        getFormalExaminationId,
        getOfficialPublication,
        getPublicationPaymentStatus,
        createOfficialPublication,
        updateOfficialPublication,
        sendPaymentEmail,
        createFlowPayment,
        getInapiDataForAutofill,
        fetchingGetFormalExaminationId,
        fetchingGetOfficialPublication,
        fetchingCreateOfficialPublication,
        fetchingUpdateOfficialPublication,
        fetchingSendPaymentEmail,
        fetchingCreateFlowPayment,
        fetchingInapiAutofill
    };
};

export default useOfficialPublicationService;

